module.exports = __webpack_public_path__ + "img/zhuangpei.asm.cab36bdb.jpg";